import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux'
import leadActionsImp from '../../Actions/leadActions'
import { useTranslation } from 'react-i18next';
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { DefaultCard } from "../Card/Card";

function LeadCustomers ({lead}) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const leadActions = bindActionCreators(leadActionsImp, dispatch);
    const customers = useSelector(state => state.LeadsReducer.leadCustomers);

    useEffect(() => {
        leadActions.clearCustomersByEmail();
        leadActions.searchCustomersByEmail(lead.email)
    }, [])

    function renderNoDataFound() {
        return (<p>{t('leadcustomers.noentriesfound')}</p>);
    }

    const onCustomerClick = (customerNumber) => {
        const url = customerRoutes.customer(customerNumber);
        window.open(url, "_blank");
    }


    if (!customers)
        return null;

    return <>
        <DefaultCard title={t('leadcustomers.customersuggestions')}>
            {!customers || customers.length === 0 && renderNoDataFound()}
            {customers.length > 0 && <>
                <div className="table-responsive" style={{height: "100%"}}>
                    <table className="table table-stripe table-hover">
                        <thead>
                        <tr>
                            <th>{t('leadcustomers.organizationnumber')}</th>
                            <th>{t('leadcustomers.customernumber')}</th>
                            <th>{t('leadcustomers.name')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {customers.map((customer, index) => {
                            return <tr className="cursorpointer" key={index}
                                       onClick={() => onCustomerClick(customer.customerNumber)}>
                                <td>{customer.organizationNumber}</td>
                                <td>{customer.customerNumber}</td>
                                <td>{customer.name}</td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                </div>
            </>}
        </DefaultCard>
    </>
}

export default LeadCustomers;